import * as Yup from "yup";

Yup.addMethod<Yup.StringSchema>(Yup.string, "hasMaxLengthAndNoSpecialChars", function (maxLength = 50) {
  return this.max(maxLength, "Value is too Long").test(
    "Special Character Test",
    "No special characters allowed",
    (value) => !new RegExp(/[“”"<>="`!?%~${}\][\\]/gm).test(value || ""),
  );
});
